export default "__VITE_ASSET__fd2f3a28__"